import { InputError } from "@app/components/core/InputError/InputError"
import { classNamez } from "@tecreation/funnel-components"

const RadioButtonsGroup = ({ label, options, formRegister, errors, onChange, className }) => {
	const errorMessage = formRegister && errors && errors[formRegister.name] ? errors[formRegister.name].message : undefined
	const groupId = formRegister?.name || "radio-group"
	const groupLabelId = `${groupId}-label`

	const handleChange = e => {
		if (formRegister?.onChange) {
			formRegister.onChange(e)
		}
		if (onChange) {
			onChange(e)
		}
	}

	return (
		<div className={className}>
			<div className="regular f5 mb-2" id={groupLabelId}>
				{label} *
			</div>
			<div className="flex" role="radiogroup" aria-labelledby={groupLabelId} aria-required="true">
				{(options || []).map((option, i) => (
					<div key={option.value} className={"flex flex-center" + classNamez({ "ml-3": i !== 0 })}>
						<input
							id={`${groupId}-${option.value}`}
							type="radio"
							{...formRegister}
							value={option.value}
							onChange={handleChange}
							aria-describedby={errorMessage ? `${groupId}-error` : undefined}
							aria-invalid={!!errorMessage}
						/>
						<label htmlFor={`${groupId}-${option.value || option.id}`} className="ml-2">
							{option.name || option.value}
						</label>
					</div>
				))}
			</div>

			{formRegister && <InputError message={errorMessage} id={`${groupId}-error`} />}
		</div>
	)
}

export default RadioButtonsGroup
